<div class="auto">
  <div class="success-wrapper">
  <div class="success-card">

    <div class="icon-wrap">
      <div class="check-circle">✓</div>
    </div>

    <h2 class="title">
      Application Submitted Successfully! 🎉
    </h2>

    <p class="subtitle">
      Thank you for your interest in joining our platform. We've received your details.
    </p>

    <div class="info-box">
      <h4>What happens next?</h4>

      <div class="info-item">
        <span class="icon">📄</span>
        <div>
          <strong>Application Review</strong>
          <p>Our team will carefully review your profile and verify the details you've provided.</p>
        </div>
      </div>

      <div class="info-item">
        <span class="icon">⏱</span>
        <div>
          <strong>We'll Get Back to You</strong>
          <p>Expect an update within 24–48 hours.</p>
        </div>
      </div>

      <div class="info-item">
        <span class="icon">✉️</span>
        <div>
          <strong>Check Your Email</strong>
          <p>We've sent a confirmation email to your registered address.</p>
        </div>
      </div>
    </div>

    <p class="footer-text">
      We appreciate your patience while we review your application.  
      If you have any questions, feel free to reach out to our support team.
    </p>

    <a href="#" class="support-link">Contact our support team</a>

  </div>
</div>

</div>